export default "__VITE_ASSET__4c7bce80__"